var castThunk = function castThunk(a) {
  return typeof a === "function" ? a : function () {
    return a;
  };
};
export { castThunk };